import axios from '@fs/zion-axios'
import { isNotNullOrUndefinedOrEmpty } from '../util/Utils'

export default () => {}

const BASE_MEMBERSHIP_PATH = '/service/dmc/membership'

export async function getMembershipSearchResults(name, birthDate, sex) {
  let queryString = `name=${encodeURIComponent(name)}`
  if (isNotNullOrUndefinedOrEmpty(birthDate)) {
    if (birthDate.length === 4) {
      queryString += `&birthYear=${encodeURIComponent(birthDate)}`
    } else {
      queryString += `&birthDate=${encodeURIComponent(birthDate)}`
    }
  }
  if (sex && (sex === 'male' || sex === 'female')) {
    queryString += `&gender=${encodeURIComponent(sex)}`
  }
  const response = await axios.get(`${BASE_MEMBERSHIP_PATH}/persons?${queryString}`)
  return response
}

export function getPersonDetails(userId) {
  const url = `${BASE_MEMBERSHIP_PATH}/${userId}/details`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getUnit(unitId) {
  const url = `${BASE_MEMBERSHIP_PATH}/unit/${unitId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getAsMember(cisId) {
  const url = `${BASE_MEMBERSHIP_PATH}/asMember?cisId=${cisId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function createAsMember(cisId, reason) {
  const url = `${BASE_MEMBERSHIP_PATH}/asMember?cisId=${cisId}&reason=${reason}`
  return axios.post(url).then((response) => {
    return response.data
  })
}

export function deleteAsMember(cisId) {
  const url = `${BASE_MEMBERSHIP_PATH}/asMember?cisId=${cisId}`
  return axios.delete(url).then((response) => {
    return response.data
  })
}
export async function resyncCmisx(mrn) {
  const url = `${BASE_MEMBERSHIP_PATH}/${mrn}/sync`
  const response = await axios.post(url)
  return response.data
}

export async function deleteIdFromCache(cisId) {
  const url = `${BASE_MEMBERSHIP_PATH}/${cisId}/deleteId`
  const response = await axios.delete(url)
  return response.data
}

export function getMemberName(mrn) {
  const url = `${BASE_MEMBERSHIP_PATH}/${mrn}/name`
  return axios.get(url).then((response) => {
    return response.data
  })
}
